// extracted by mini-css-extract-plugin
export var footer = "_he-0";
export var inherit = "_he-1";
export var input = "_he-2";
export var modalContent = "_he-3";
export var quillEditor = "_he-4";
export var subtitle = "_he-5";